var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"header"}),_c('v-img',{attrs:{"src":require("@/assets/logo_login.png"),"max-height":"300"}}),_c('h1',{staticClass:"text-center"},[_vm._v("BIENVENIDO")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }